/* eslint semi:0 */
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import { external } from '../../../utils/script'
import { makeSafeFn } from '../../../utils/fn'

let comscore = external.load({
  name: 'comscore',
  loadNow: true,
})

//NOTICE: this class should be (and is) used only when not in native app
class ComscoreService extends AnalyticsBaseService {
  get className() {
    return 'ComscoreService'
  }

  pageViewed() {
    this.trackEvent({})
  }

  trackEvent(data) {
    this.logAnalytics(data)
    comscore(makeSafeFn(() => window.COMSCORE.beacon(data)))
  }
}

export default ComscoreService



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/comscoreService.js